import React from 'react';

export default function Footer(props) {

    return (
        <div className="footer-container">
            <img className="p-2" src="Poweredby_Conduent.svg" alt="Powered by Conduent"></img>
        </div>
    )
}
